module.exports = __webpack_public_path__ + "img/navegacao-anterior.2bc73c50.svg";